"use client";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./style.css";
import ConnectWallet from "./ConnectWallet";
import { useAppKit, useAppKitAccount } from "@reown/appkit/react";
import { useNavigate } from "react-router-dom";

export function Navigation() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { open } = useAppKit();
  const { isConnected, address } = useAppKitAccount();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const loadUser = () => {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        setUser(JSON.parse(storedUser));
      } else {
        setUser(null);
      }
    };

    loadUser();
    window.addEventListener("storage", loadUser);

    return () => {
      window.removeEventListener("storage", loadUser);
    };
  }, []);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") setMenuOpen(false);
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("user");
    setUser(null);
    setMenuOpen(false);
    navigate("/login"); // Redirect to login
  };

  

  return (
    <nav className="w-full bg-transparent relative z-50">
      <div className="flex items-center justify-between px-4 py-3 max-w-[1344px] mx-auto">
        {/* Logo */}
        <div className="flex items-center h-16 w-[163px] flex-shrink-0 lg:-ml-10">
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/8f797322cd4d5eb87a527bf3e8739feba70e3082?placeholderIfAbsent=true&apiKey=0c11d46dd7d64d7a84bf3e17dbee5689"
            className="object-contain shrink-0 aspect-[0.78] w-[50px]"
            alt="Unicorn logo"
          />
          <div className="relative ml-2 h-[51px] w-[106px]">
            <div className="absolute top-0 left-0 text-2xl font-semibold leading-6 text-white uppercase h-[26px] w-[61px]">
              Baby
            </div>
            <div className="absolute left-0 top-[25px] text-2xl font-semibold leading-6 text-white uppercase h-[26px] w-[106px]">
              Unicorn
            </div>
          </div>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden lg:flex items-center gap-8">
          <Link to="/" className="text-xl font-medium text-white hover:text-[#FF6EB3]">Home</Link>
          <a href="#tokenomics" className="text-xl font-medium text-white hover:text-[#FF6EB3]">Tokenomics</a>
          <a href="#roadmap" className="text-xl font-medium text-white hover:text-[#FF6EB3]">Roadmap</a>
          <Link to="https://babyu-sale.tech/" className="text-xl font-medium text-white hover:text-[#FF6EB3]">Presale</Link>
          <Link to="https://babyu-staking.tech/" className="text-xl font-medium text-white hover:text-[#FF6EB3]">Staking</Link>
          <Link to="/vesting" className="text-xl font-medium text-white hover:text-[#FF6EB3]">Vesting</Link>

          {user ? (
            <div className="flex items-center gap-4">
              <Link
                to="/profile"
                className="flex items-center gap-2 px-4 py-2 text-white rounded-md bg-[linear-gradient(90deg,#FF6EB3_0%,#AA81FF_47.12%,#6BC9FF_100%)]"
              >
                <img
                  src="/img1.png"
                  alt="Profile"
                  className="w-8 h-8 rounded-full border"
                />
                <span className="text-white font-medium">
                  {user.username || user.name || user.email.split("@")[0]}
                </span>
              </Link>

              <button
                onClick={handleLogout}
                className="px-3 py-3 text-white rounded-md bg-[linear-gradient(90deg,#FF6EB3_0%,#AA81FF_47.12%,#6BC9FF_100%)]"
              >
                Logout
              </button>
            </div>
          ) : (
            <div className="button-row">
              <Link to="/register" className="frame-53">
                <div className="text-white">Register</div>
              </Link>
              <Link to="/login" className="frame-53">
                <div className="text-white">Login</div>
              </Link>
            </div>
          )}

          <ConnectWallet
            label="Connect wallet"
            accountStatus="address"
            showBalance={false}
          />
        </div>

        {/* Mobile Hamburger Button */}
        <button
          className="lg:hidden focus:outline-none"
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          <svg
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="url(#grad1)"
            strokeWidth="2"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient id="grad1" x1="0" y1="0" x2="100%" y2="0">
                <stop offset="0%" stopColor="#FFA8D1" />
                <stop offset="50%" stopColor="#C3B1FF" />
                <stop offset="100%" stopColor="#AEE2FF" />
              </linearGradient>
            </defs>
            <path d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      {menuOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-95 flex flex-col items-center pt-24 gap-8 lg:hidden z-50">
          <button
            className="absolute top-6 right-6 text-4xl"
            onClick={() => setMenuOpen(false)}
          >
            <svg
              width="36"
              height="36"
              viewBox="0 0 24 24"
              stroke="url(#grad2)"
              strokeWidth="2.5"
              xmlns="http://www.w3.org/2000/svg"
            >
              <defs>
                <linearGradient id="grad2" x1="0" y1="0" x2="100%" y2="0">
                  <stop offset="0%" stopColor="#FFA8D1" />
                  <stop offset="50%" stopColor="#C3B1FF" />
                  <stop offset="100%" stopColor="#AEE2FF" />
                </linearGradient>
              </defs>
              <path d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          <nav className="flex flex-col gap-6 items-center w-full">
            <Link to="/" onClick={() => setMenuOpen(false)} className="text-2xl text-white font-semibold">Home</Link>
            <a href="#tokenomics" onClick={() => setMenuOpen(false)} className="text-2xl text-white font-semibold">Tokenomics</a>
            <a href="#roadmap" onClick={() => setMenuOpen(false)} className="text-2xl text-white font-semibold">Roadmap</a>
            <Link to="https://babyu-sale.tech/" onClick={() => setMenuOpen(false)} className="text-2xl text-white font-semibold">Presale</Link>
            <Link to="https://babyu-staking.tech/" onClick={() => setMenuOpen(false)} className="text-2xl text-white font-semibold">Staking</Link>
            <Link to="/vesting" onClick={() => setMenuOpen(false)} className="text-2xl text-white font-semibold">Vesting</Link>
          </nav>

          <div className="flex flex-col gap-4 mt-8 w-4/5">
            {user ? (
              <>
                <Link to="/profile" onClick={() => setMenuOpen(false)}>
                  <div className="py-3 rounded-md text-center text-white bg-[#3a335066]">
                    {user.username || user.name || "My Profile"}
                  </div>
                </Link>
                <button
                  onClick={handleLogout}
                  className="py-3 text-center rounded-md text-white font-semibold bg-[#ff4d6d]"
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link to="/login" onClick={() => setMenuOpen(false)} className="w-full">
                  <div className="frame-53 text-center py-3 rounded-md text-white font-semibold w-full">Login</div>
                </Link>
                <Link to="/register" onClick={() => setMenuOpen(false)} className="w-full">
                  <div className="frame-53 text-center py-3 rounded-md text-white font-semibold w-full">Register</div>
                </Link>
              </>
            )}

            <button
              className="px-8 py-3 text-white rounded-md bg-[linear-gradient(90deg,#FF6EB3_0%,#AA81FF_47.12%,#6BC9FF_100%)] w-full"
              onClick={isConnected ? () => open("Account") : () => open("Connect")}
            >
              {isConnected
                ? `${address?.substring(0, 4)}...${address?.slice(-4)}`
                : "Connect"}
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
